import { useEffect, useState } from "react";

/* 最上位のスクロールを無効化する */
export const useScrollDisabled = () => {
  const [isLocked, setIsLocked] = useState(true);

  useEffect(() => {
    if (isLocked) {
      // スクロールを無効にする
      document.body.style.overflow = "hidden";
    } else {
      // スクロールを有効に戻す
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLocked]);

  return { setIsLocked };
};
